import { render, staticRenderFns } from "./ActivityListTable.vue?vue&type=template&id=51240107&scoped=true&"
import script from "./ActivityListTable.vue?vue&type=script&lang=js&"
export * from "./ActivityListTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivityListTable.vue?vue&type=style&index=0&id=51240107&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51240107",
  null
  
)

export default component.exports